module.exports = __webpack_public_path__ + "media/images/arrow-1-97b2fbd7.png";